export default __webpack_public_path__ + "static/media/roadhog-hook3.59ef57d0.mp3";